/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Question
 */
export interface Question {
    /**
     * 
     * @type {number}
     * @memberof Question
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    image?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Question
     */
    sortIndex: number;
    /**
     * 
     * @type {number}
     * @memberof Question
     */
    category: number;
}

/**
 * Check if a given object implements the Question interface.
 */
export function instanceOfQuestion(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "sortIndex" in value;
    isInstance = isInstance && "category" in value;

    return isInstance;
}

export function QuestionFromJSON(json: any): Question {
    return QuestionFromJSONTyped(json, false);
}

export function QuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Question {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'type': json['type'],
        'image': !exists(json, 'image') ? undefined : json['image'],
        'sortIndex': json['sort_index'],
        'category': json['category'],
    };
}

export function QuestionToJSON(value?: Question | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'type': value.type,
        'image': value.image,
        'sort_index': value.sortIndex,
        'category': value.category,
    };
}

